module.exports = __webpack_public_path__ + "img/do-not-click.21e61aa6.png";